import { Particle, ParticleModes } from "../../../engine/anims/Particle";
import Colors from "../../Colors";

export class LookParticle<T> extends Particle<T> {
  initialFG: string | null = null;
  initialChar: string | null = null;
}

export const LookParticleBreed = {
  mode: ParticleModes.DRAW_OVER_LAST,
  char: ">",
  fg: Colors.RED,
  bg: null,
  animate: async (particle: Particle<void>) => {
    (particle as LookParticle<void>).initialFG =
      (particle as LookParticle<void>).initialFG || particle.fg;
    (particle as LookParticle<void>).initialChar =
      (particle as LookParticle<void>).initialChar || particle.char;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      particle.char = (particle as LookParticle<void>).initialChar;
      particle.fg = (particle as LookParticle<void>).initialFG;
      await new Promise((r) => {
        window.setTimeout(r, 500);
      });

      particle.char = null;
      particle.fg = null;
      await new Promise((r) => {
        window.setTimeout(r, 500);
      });
    }
  },
};
